import { createAsyncThunk } from "@src/store/createAsyncThunk";
import {
  getExperienceBasicInfo,
  getVariationNameById,
} from "@src/store/slices/experienceBuilder/common/selectors/getVisualBuilderTrackingContext";
import { experienceBuilderSlice } from "@src/store/slices/experienceBuilder/slice";
import { mpVisualBuilderElementSelected } from "@src/utils/mixpanel";
import { EmbeddedNodeType } from "@intelligems/ig-types";

export interface TrackElementSelectedPayload {
  selector: string;
  elementType: EmbeddedNodeType;
  originalText?: string;
}

// Dedupe rapid duplicate events (e.g., from message proxy double-firing)
let lastEvent: { selector: string; timestamp: number } | null = null;
const DEDUPE_WINDOW_MS = 200;

export const trackElementSelected = createAsyncThunk<
  void,
  TrackElementSelectedPayload
>("experienceBuilder/tracking/elementSelected", (payload, { getState }) => {
  const now = Date.now();
  if (
    lastEvent &&
    lastEvent.selector === payload.selector &&
    now - lastEvent.timestamp < DEDUPE_WINDOW_MS
  ) {
    return;
  }
  lastEvent = { selector: payload.selector, timestamp: now };
  const experienceInfo = getExperienceBasicInfo(getState());
  if (!experienceInfo) return;

  const { experienceId, experienceName, experienceType } = experienceInfo;
  const variationId =
    experienceBuilderSlice.selectors.getVariationId(getState());
  const getVariationName = getVariationNameById(getState());
  const variationName = getVariationName(variationId);
  const device = experienceBuilderSlice.selectors.getDevice(getState());

  mpVisualBuilderElementSelected({
    experienceId,
    experienceName,
    experienceType,
    selector: payload.selector,
    elementType: payload.elementType,
    originalText: payload.originalText,
    groupName: variationName,
    builderMode: device,
  });
});
